module.exports = __webpack_public_path__ + "static/grading-00a79945c0edec5d23f7b4be29794062.jpg";